import lazyLoad from './Components/lazyLoad';
import ShopFilters from './Components/ShopFilters';
import InitAddToCart from './Components/initAddToCart';
import CustomSelect from './Components/CustomSelect';
import LayoutSwitcher from './Components/layoutswitcher';

document.addEventListener('DOMContentLoaded', () => {
    const filters = new ShopFilters();
    filters.init();
    filters.initButtonTogglers();
    initCustomSelects();
    initLayoutSwitcher();
    // stopPropagationOnButtons();
});

const initCustomSelects = async () => {
    const selects = document.querySelectorAll('select');

    selects.forEach((select) => {
        const custom = new CustomSelect();

        custom.init(select);
    });
};

const stopPropagationOnButtons = () => {
    const buttons = document.querySelectorAll('.button-on-table-layout ');

    buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
        });
    });
};

const initLayoutSwitcher = async () => {
    new LayoutSwitcher();
};

jQuery(document).on('ajaxComplete', (e) => {
    lazyLoad();
    new InitAddToCart();
    new ShopFilters().init();
    initCustomSelects();
    initLayoutSwitcher();
});
